export const PORNDOE_BRAND_TYPE = {
  AMATEUREURO: 'AMATEUREURO',
  DOEGIRLS: 'DOEGIRLS',
  LETSDOEIT: 'LETSDOEIT',
  MAMACITAZ: 'MAMACITAZ',
  SUPERBE: 'SUPERBE',
  TRANSBELLA: 'TRANSBELLA',
  VIPSEXVAULT: 'VIPSEXVAULT',
};

export const getPorndoeBrandType = (affiliateCode) => {
  const affilateCodeArray = affiliateCode?.split?.('_');

  if (affilateCodeArray[0] !== 'hasOffers') {
    return null;
  }

  const purchasesIdIndex = affilateCodeArray.length - 2;
  const purchaseId = affilateCodeArray[purchasesIdIndex];

  const subscriptionIdIndex = affilateCodeArray.length - 1;
  const subscriptionId = affilateCodeArray[subscriptionIdIndex];

  if (purchaseId === '5119' && subscriptionId === '5118') {
    return PORNDOE_BRAND_TYPE.TRANSBELLA;
  }
  if (purchaseId === '5122' && subscriptionId === '5121') {
    return PORNDOE_BRAND_TYPE.DOEGIRLS;
  }
  if (purchaseId === '5125' && subscriptionId === '5124') {
    return PORNDOE_BRAND_TYPE.VIPSEXVAULT;
  }
  if (purchaseId === '5128' && subscriptionId === '5127') {
    return PORNDOE_BRAND_TYPE.MAMACITAZ;
  }
  if (purchaseId === '5131' && subscriptionId === '5130') {
    return PORNDOE_BRAND_TYPE.AMATEUREURO;
  }
  if (purchaseId === '5134' && subscriptionId === '5133') {
    return PORNDOE_BRAND_TYPE.SUPERBE;
  }
  if (purchaseId === '5096' && subscriptionId === '5095') {
    return PORNDOE_BRAND_TYPE.LETSDOEIT;
  }

  return null;
};
